import artifact from '$houdini/artifacts/CreateVehicleAttachment'
import { MutationStore } from '../runtime/stores/mutation'

export class CreateVehicleAttachmentStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
